import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .07)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState('');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography variant="h3" style={{ color: 'rgba(0, 0, 0, .7)', textAlign: 'left' }}>Electrical Control and Instrumentation Design, Design Review, and Safety Case support</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ color: 'rgba(0, 0, 0, .7)', textAlign: 'left', fontSize: '1.5em' }} >
          Design consultancy services provided for industries including Civil Nuclear, Defence Nuclear, Oil & Gas, and Petrochemicals. Our experience includes major projects in the UK, Europe, and North America including: BP Chemicals at Saltend, Rolls-Royce Gas Turbine projects for power and gas compression in the UK, North America, South America, and Europe, a major defense contractor in the UK and Europe, Sizewell B and Culham Centre for Fusion Energy.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography style={{ color: 'rgba(0, 0, 0, .7)', textAlign: 'left' }} variant="h3">Engineering Management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ color: 'rgba(0, 0, 0, .7)', textAlign: 'left', fontSize: '1.5em' }}>
          Engineering management consultancy services provided ranging from Engineering Manager to Head of Discipline, to Head of Engineering level.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography variant="h3" style={{ color: 'rgba(0, 0, 0, .7)', textAlign: 'left' }}>Electrical Control and Instrumenatation Inspection</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ color: 'rgba(0, 0, 0, .7)', textAlign: 'left', fontSize: '1.5em' }}>
          We provide third party inspections backed by Aramco Overseas Company (AOC) qualifications: QM01, 02, 16, 17, 23, 36, 40, 46, 47, 48 & 49. Our experience includes: Sea water injection pump controls, valve actuators, heaters and thyristor control panels, emergency shower units, MV electrical subsea umbilicals, and oil platform navigational aids.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
          <Typography variant="h3" style={{color: 'rgba(0, 0, 0, .7)', textAlign: 'left' }}>Nuclear/Process Safety Case support: HAZID, HAZOP, LOPA & PRS/PSR Functional Safety design and verification in accordance with IEC 61511 and 61508</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{color: 'rgba(0, 0, 0, .7)', textAlign: 'left', fontSize: '1.5em' }}>Support from an engineer with an MSc in Nuclear Technology (NTEC) and TUV certified as a Functional Safety Professional.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
          <Typography variant="h3" style={{color: 'rgba(0, 0, 0, .7)', textAlign: 'left' }}>Document Control and Technical Admin. support</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{color: 'rgba(0, 0, 0, .7)', textAlign: 'left', fontSize: '1.5em' }}>Document Control support in accordance with ISO 9001 and ISO 19475, and general technical admin.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}